import { render } from "./clientDIDNumbers.vue?vue&type=template&id=16d469b4&scoped=true"
import script from "./clientDIDNumbers.vue?vue&type=script&lang=js"
export * from "./clientDIDNumbers.vue?vue&type=script&lang=js"

import "./clientDIDNumbers.vue?vue&type=style&index=0&id=16d469b4&scoped=true&lang=scss"
import "./clientDIDNumbers.vue?vue&type=style&index=1&id=16d469b4&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d469b4"]])

export default __exports__